export default __webpack_public_path__ + "static/AppMoneyWalkie3-94069e78a4a0c2255fcf2780fc6b5135.png";